module.exports = __webpack_public_path__ + "static/media/Kyle Dunaway Headshot_1590163208745.7f5bb34f.jpeg";